export interface BlobDto {
  id: number
  url: string
  type: BlobType
}

export enum BlobType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  PDF = 'PDF',
  XK_MERGE_JSON = 'XK_MERGE_JSON',
  AUDIO = 'AUDIO',
}
